import React from 'react';
import {   InfoBox,   ExerciseBox,   CodeBlock,   InlineCode, BoldTextParagraph,  SectionTitle, MutedText, Note, Separator, TableContainer,  Highlight,  PatternContainer,  SectionHeading,  SubHeading,  TwoColGrid,  ThreeColGrid,  GridItem,  Divider} from '../../../../components/course/CourseComponents';

const Chapitre1Content = ({ courseId = 'monpremierjeu' }) => {
  return (
    <>
      <InfoBox title=" C’est quoi la programmation ?" color="blue">
        <p className="mb-0">
        La programmation, c’est l’art de dire à ton ordinateur ce qu’il doit faire, étape par étape, avec un langage spécial qu’il comprend.
        </p>
      </InfoBox>  
      
      
      <p>
      Il existe beaucoup de langages de programmation, comme le <InlineCode>C, le C++, Java, C#, Python, JavaScript…</InlineCode> <br/>Certains sont très bas niveau comme le <InlineCode>C</InlineCode> : ils sont très rapides à l’exécution, mais plus compliqués à comprendre.
      <br/>D'autres sont dits de plus haut niveau comme le <InlineCode>JavaScript</InlineCode> : plus faciles à utiliser, plus permissifs, mais un peu moins rapides.
      </p>
      <Note type="tip" title="">
      Mais au final, tous ces langages servent à la même chose : dire à ton ordinateur ce qu’il doit faire.
      </Note>
      <p>
      💡 On retrouve de la programmation dans tous les appareils électroniques : ton téléphone, ta télévision, ta voiture, et même ta machine à laver !
      Chaque langage a sa propre syntaxe, mais une fois que tu as compris la logique, il est facile d'en utiliser d'autres.
      </p>
      <Note type="tip" title="">
      L’important dans la programmation, c’est de comprendre la LOGIQUE. Tu peux ensuite écrire cette logique dans n’importe quel langage.
      </Note>
      <p>Programmer te donne le pouvoir de créer ce que tu imagines, avec juste un clavier.<br/>
      Tu n’as pas besoin d’être un génie en maths pour commencer.  Ce qu’il faut surtout, c’est de la logique, de la patience, et l’envie d’apprendre.<br/>
      Plus tu pratiques, plus tu comprends comment ça fonctionne.<br/>
      </p>


      <Note type="tip" title="">
      Le but de cette formation est de t’apprendre à réfléchir comme un programmeur, et à penser de manière simple et logique.
      </Note>

      <p>
      🎯 Pour cette formation, on va utiliser le langage <InlineCode>JavaScript</InlineCode>, car il est très simple et s’exécute facilement dans ton navigateur. <br/>Comme ça, tu n’auras pas besoin d’installer un environnement de développement compliqué. Tu pourras tout faire depuis ce site : écrire du code et l’exécuter sans rien d’autre à installer.
      </p>
      <p>
        Voici un exemple de programme simple en javascript :
      </p>

      <Note type="gray" title="Code en javascript :">
      <CodeBlock language="javascript">
{`let score = 85;
if (score >= 50) {
  print("Bravo, tu as réussi !");
} else {
  print("Dommage, essaie encore !");
}`}
        </CodeBlock>
      </Note>
      <MutedText>💡 Pour le moment c'est normal si tu ne comprends pas ce code, mais ça devrai rapidement changer !
      </MutedText>
      <BoldTextParagraph>Il est temps d’écrire ta première ligne de code !</BoldTextParagraph>

    </>
  );
};

export default Chapitre1Content; 